module.exports = __webpack_public_path__ + "media/intro_with_long_HU.ce527523.mp3";